import { render, staticRenderFns } from "./EmailGroupUpdate.vue?vue&type=template&id=3d04bbc0&"
import script from "./EmailGroupUpdate.vue?vue&type=script&lang=js&"
export * from "./EmailGroupUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports